<template>
  <div>
    <div
      class="topDiv"
      ref="customSelect"
      :class="!id && 'mt-3'"
      @focusout="closeDropdownOnFocusOut"
    >
      <div
        v-if="!noLabel"
        class="acs-input-head"
        :style="id && 'font-size: 14px !important;'"
      >
        Source
      </div>
      <div
        class="
          laptopinput
          d-flex
          align-items-center
          justify-content-between
          pointer
        "
        @click="(sourceDropdown = !sourceDropdown), (thirdParty = false)"
      >
        <span
          :class="
            selectedValues.length > 0
              ? 'inputPlaceholder-font'
              : 'input-empty-placeholder'
          "
        >
          {{
            selectedValues.length > 0
              ? `${selectedValues.length}${label ? " " + label : ""} selected`
              : placeholder
          }}
        </span>
        <img
          v-if="!sourceDropdown"
          src="../../../assets/cvsearch/cv-downarrow.svg"
          alt=""
        />
        <img
          v-else
          class="pointer"
          src="../../../assets/cvsearch/cv-uparrow.svg"
          alt=""
        />
      </div>
      <div
        :class="from == 'scroll-filter' && 'overflow-xy'"
        :style="from == 'scroll-filter' && 'max-height: 110px !important;'"
        ref="scrollContainer"
        class="source-dropdown tp-checkbox-group newtp-checkbox"
        v-if="sourceDropdown"
      >
        <b-form-group>
          <b-form-checkbox
            v-for="option in options"
            v-model="selectedValues"
            :key="option.value"
            :value="option.value"
            name="flavour-3a"
            @change="$emit('setValue', selectedValues)"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-form-group>
        <!-- SELECTED CLASS - source-sing-sel -->
        <div
          class="source-sing position-relative pointer"
          v-if="showThirdParty && from != 'scroll-filter'"
        >
          <div
            @click="thirdParty = !thirdParty"
            class="d-flex align-items-center justify-content-between"
          >
            <span>Third Party</span>
            <img src="../../../assets/talentpool/rightArrow.svg" alt="" />
          </div>
          <div class="tp-source-drop" v-if="thirdParty">
            <b-form-checkbox
              v-for="option in thirdPartyOptions"
              v-model="selectedValues"
              :key="option.value"
              :value="option.value"
              name="flavour-3a"
              @change="$emit('setValue', selectedValues)"
            >
              {{ option.text }}
            </b-form-checkbox>
          </div>
        </div>
        <template v-else>
          <div
            :class="
              selectedValues &&
              selectedValues.includes('CV Search') &&
              'source-sing-sel'
            "
            class="source-sing position-relative pointer"
            v-if="showThirdParty"
          >
            <div
              @click="(thirdParty = !thirdParty), scrollToBottom()"
              class="d-flex align-items-center justify-content-between"
            >
              <span>Third Party</span>
              <img
                v-if="!thirdParty"
                src="@/assets/cvsearch/cv-downarrow.svg"
                alt
              />
              <img v-else src="@/assets/cvsearch/cv-uparrow.svg" alt />
            </div>
          </div>
          <b-collapse
            :visible="thirdParty"
            class="status-collapse source-collapse"
          >
            <b-card class="card-set">
              <ul>
                <li>
                  <b-form-checkbox
                    v-for="option in thirdPartyOptions"
                    v-model="selectedValues"
                    :key="option.value"
                    :value="option.value"
                    name="flavour-3a"
                    @change="$emit('setValue', selectedValues)"
                  >
                    {{ option.text }}
                  </b-form-checkbox>
                </li>
              </ul>
            </b-card>
          </b-collapse>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sourceDropdown: false,
      thirdParty: false,
      selectedValues: [], // Must be an array reference!
      options: [
        {
          value: "naukri",
          text: "Naukri",
        },
        {
          value: "monster",
          text: "Monster",
        },
        {
          value: "indeed",
          text: "Indeed",
        },
        {
          value: "linkedin",
          text: "Linkedin",
        },
        {
          value: "vendor",
          text: "Vendor",
        },
        {
          value: "other",
          text: "Others",
        },
      ],
      thirdPartyOptions: [
        {
          value: "CV Search",
          text: "CV Search",
        },
      ],
    };
  },
  props: {
    label: String,
    noLabel: { type: Boolean, default: false },
    placeholder: String,
    showThirdParty: Boolean,
    hideVendor: Boolean,
    id: String,
    from: String,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  watch: {
    vmodel() {
      this.selectedValues = this.vmodel;
    },
  },
  created() {
    if (this.vmodel) {
      this.selectedValues = this.vmodel;
    }
    if (this.hideVendor) {
      this.options = this.options.filter((obj) => obj.text !== "Vendor");
    }
  },
  mounted() {
    document.addEventListener("click", this.closeDropdownOnClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdownOnClickOutside);
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTo({
              top: container.scrollHeight,
              behavior: "smooth",
            });
          }
        }, 300); // Slight delay ensures content is loaded
      });
    },
    closeDropdownOnClickOutside(event) {
      if (!this.$refs.customSelect.contains(event.target)) {
        this.sourceDropdown = false;
        this.thirdParty = false;
      }
    },
    closeDropdownOnFocusOut(event) {
      const customSelect = this.$refs.customSelect;
      const relatedTarget = event.relatedTarget || document.activeElement;
      if (!customSelect.contains(relatedTarget)) {
        // Check if the clicked element is NOT a checkbox
        if (
          event.target.tagName.toLowerCase() !== "input" ||
          event.target.type !== "checkbox"
        ) {
          this.sourceDropdown = false; // Close the dropdown
          this.thirdParty = false;
        }
      }
    },
  },
};
</script>

<style lang="postcss" scoped></style>
